import { cn } from "@/lib/utils";

interface AuditLogEmptyProps {
  className?: string;
}

export function AuditLogEmpty({ className }: AuditLogEmptyProps) {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <circle
        cx="60"
        cy="60"
        r="46"
        style={{ fill: "hsl(var(--muted))", stroke: "hsl(var(--border))" }}
        strokeWidth="1.5"
      />
      <circle
        cx="60"
        cy="60"
        r="30"
        style={{ fill: "none", stroke: "hsl(var(--border))" }}
        strokeWidth="1.5"
      />
      <circle
        cx="60"
        cy="60"
        r="14"
        style={{ fill: "none", stroke: "hsl(var(--border))" }}
        strokeWidth="1.5"
      />
      <line
        x1="60"
        y1="60"
        x2="89"
        y2="31"
        style={{ stroke: "hsl(var(--primary))" }}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle
        cx="83"
        cy="37"
        r="4"
        style={{ fill: "hsl(var(--primary))" }}
      />
    </svg>
  );
}
